import { useContext, createContext } from 'react';

export const IsReadOnlyContext = createContext<boolean>(false);
export const useIsReadOnlyContext = () => useContext(IsReadOnlyContext);
